import "core-js/modules/es6.object.assign";
import "core-js/modules/es6.object.create";
import "core-js/modules/es6.object.set-prototype-of";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

import * as React from 'react';
import { AnyColor } from '../../../../types/color';
import { Logo } from '../Logo';

var Image = function Image() {
  return React.createElement("svg", {
    height: "546px",
    version: "1.1",
    viewBox: "0 0 569 546",
    width: "569px",
    xmlns: "http://www.w3.org/2000/svg"
  }, React.createElement("title", null, "Patreon logo"), React.createElement("g", null, React.createElement("circle", {
    cx: "362.589996",
    cy: "204.589996",
    "data-fill": "1",
    r: "204.589996"
  }), React.createElement("rect", {
    "data-fill": "2",
    height: "545.799988",
    width: "100",
    x: "0",
    y: "0"
  })));
};

var PatreonMark =
/** @class */
function (_super) {
  __extends(PatreonMark, _super);

  function PatreonMark() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  PatreonMark.prototype.render = function () {
    return React.createElement(Logo, __assign({}, this.props), React.createElement(Image, null));
  };

  PatreonMark.defaultProps = {
    colors: [AnyColor.LegacyCoral, AnyColor.LegacyNavy]
  };
  return PatreonMark;
}(React.Component);

export { PatreonMark };